export default __webpack_public_path__ + "static/O0169-8f65480533f43e2260c7d7ceffaa01d0.png";